/* urlを見て、親要素 > li > aのhref属性を見て、pathnameと等しければliにactiveを付与する
 * クラスを付与してなければ最初の要素の.js-add-active-to-nav-itemにactiveを付与
 *
*/

const wrapperElementsNodes = document.querySelectorAll('.js-nav-path-wrapper');
const $wrapperElements = Array.prototype.slice.call(wrapperElementsNodes, 0);

const addActiveToNavAsPath = ($wrapper) => {
  const itemElementsNodes = $wrapper.querySelectorAll('.js-nav-path-item');
  const $itemElements = Array.prototype.slice.call(itemElementsNodes, 0);

  let isHome = true;

  function getPathFromUrl () {
    return location.pathname.split('/')[1];
  }

  function removeAllClass () {
    $itemElements.forEach(el => {
      if (el.classList.contains('active')) {
        el.classList.remove('active');
      }
    });
  }

  function addActiveClass () {
    $itemElements.forEach(el => {
      const linkPath = el.querySelector('a').getAttribute('href').split('/')[1];
      if (linkPath === getPathFromUrl()) {
        el.classList.add('active');
        isHome = false;
      }
    });
    if (isHome) {
      $itemElements[0].classList.add('active');
    }
  }

  function init () {
    removeAllClass();
    addActiveClass();
  }

  init();
};

window.addEventListener('DOMContentLoaded', () => {
  if ($wrapperElements !== null) {
    $wrapperElements.forEach(el => {
      addActiveToNavAsPath(el);
    });
  }
});
